export class Address {
    Line1?: string;
    Line2?: string;
    Suite?: string;
    City?: string;
    State?: string;
    Zipcode?: string;
}
